import countryToIso2 from './data/countries.json';

export type CountryName = keyof typeof countryToIso2;

export const getCountryIso2 = (countryName: CountryName) => {
  return countryToIso2[countryName]?.iso2 as CountryName ?? '';
};
